import React from 'react'
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner
} from 'reactstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Select from 'react-select'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../../../../components/AlertMessage'
import projectLanguagesActions from '../actions'

class CreationModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Locale to create to compare with references locales
      locale: null,
      noSelectedLanguage: false
    }
  }

  componentDidUpdate(prevProps) {
    const {
      creationStatus: prevCreationStatus
    } = prevProps

    const {
      creationStatus,
      isOpen
    } = this.props

    if (isOpen === false) return

    if (prevCreationStatus === 'creation' && creationStatus === 'succeeded') {
      this.toggle()
      this.resetLocale()
    }
  }

  onSubmit(event) {
    const {
      dispatch,
      projectId
    } = this.props

    const { locale } = this.state

    event.preventDefault()

    if (locale === null) {
      this.setState({
        noSelectedLanguage: true
      })
    } else {
      dispatch(projectLanguagesActions.create(projectId, locale))
    }
  }

  onLocalesSelect(locale) {
    this.setState({
      locale
    })
  }

  resetLocale() {
    this.setState({
      noSelectedLanguage: false
    })
  }

  toggle() {
    const { toggle } = this.props

    this.setState({
      locale: null
    }, () => toggle())
  }

  render() {
    const {
      creationError,
      creationStatus,
      isOpen,
      locales,
      t
    } = this.props

    const {
      locale,
      noSelectedLanguage
    } = this.state

    const noOptionsMessage = () => (
      <p>
        {t('labels.noOptions', { ns: 'ProjectsPage' })}
        <Link
          className="text-secondary font-weight-bold"
          name="create-locales"
          to="/locales"
        >
          {t('labels.noOptionsLink', { ns: 'ProjectsPage' })}
        </Link>
      </p>
    )

    return (
      <Modal isOpen={isOpen} toggle={() => this.toggle()}>
        <Form id="project-language-creation-modal">
          <ModalHeader toggle={() => this.toggle()}>
            {t('ProjectLanguageCreationModal.title', { ns: 'ProjectLanguagesPage' })}
          </ModalHeader>
          <ModalBody className="d-flex flex-column">
            <FormGroup className="position-relative">
              <Label for="locales">
                {t('ProjectLanguageCreationModal.label', { ns: 'ProjectLanguagesPage' })}
              </Label>
              <Select
                id="locales"
                onChange={(selected) => this.onLocalesSelect(selected)}
                openMenuOnFocus
                options={locales}
                noOptionsMessage={() => noOptionsMessage()}
                placeholder={t('fields.localesPlaceholder', { ns: 'ProjectsPage' })}
                value={locale}
              />
              {noSelectedLanguage && (
                <FormFeedback className="d-block z-0" tooltip>
                  {t('errors.required_field', { ns: 'commons' })}
                </FormFeedback>
              )}
              {creationStatus === 'creation' && (
                <>
                  <Spinner className="mt-2 text-secondary" />
                  <span className="ms-3">
                    {t('ProjectLanguageCreationModal.creationProjectLanguage', { ns: 'ProjectLanguagesPage' })}
                  </span>
                </>
              )}

              {creationStatus === 'failed' && (
                <AlertMessage className="mt-2">
                  {typeof creationError === 'string'
                    ? creationError
                    : t('errors.somethingWentWrong', { ns: 'commons' })}
                </AlertMessage>
              )}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.toggle()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="primary"
              onClick={(event) => this.onSubmit(event)}
            >
              {t('buttons.add', { ns: 'commons' })}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

CreationModal.propTypes = {
  creationError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  creationStatus: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  locales: PropTypes.arrayOf(PropTypes.object),
  projectId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired
}

CreationModal.defaultProps = {
  creationError: null,
  creationStatus: 'idle',
  locales: null
}

const mapStateToProps = ({
  locales: {
    items: locales
  },
  projectLanguages: {
    creationError,
    creationStatus
  }
}) => ({
  creationError,
  creationStatus,
  locales
})

export default withTranslation(['ProjectLanguagesPage', 'ProjectsPage', 'commons'])(
  connect(mapStateToProps)(CreationModal)
)
